export const UPDATE_TAROT_TYPE = "UPDATE_TAROT_TYPE"
// export const UPDATE_TAROT_TEXT = "UPDATE_TAROT_TEXT"
// export const UPDATE_ALL_TAROT_SETTINGS = "UPDATE_ALL_TAROT_SETTINGS"
export const UPDATE_TAROT_DECK = "UPDATE_TAROT_DECK"
export const UPDATE_DRAW_MODE = "UPDATE_DRAW_MODE"
export const UPDATE_CARDS_READ = "UPDATE_CARDS_READ"
export const UPDATE_IS_ANIMATION_RUNNING = "UPDATE_IS_ANIMATION_RUNNING"
export const OPEN_FINAL_SELECTION_MODAL = "OPEN_FINAL_SELECTION_MODAL"
export const OPEN_RESTART_CONFIRMATION_MODAL = "OPEN_RESTART_CONFIRMATION_MODAL"
